import { createSelector } from '@ngrx/store';

export const getImageTypesState = createSelector(
    (state: any) => state.imageTypes,
    (state: any) => state.get('list')
);

export const getCreateImageTypeState = createSelector(
    (state: any) => state.imageTypes,
    (state: any) => state.get('createImageType')
);

export const getUpdateImageTypeState = createSelector(
    (state: any) => state.imageTypes,
    (state: any) => state.get('updateImageType')
);
 